import { sortBy } from 'lodash';
import { CalculsFormScolaire } from 'src/constants/calculs';
import {
  PrejudiceFormScolaire,
  PrejudiceFormScolairePerteDeChance,
  PrejudiceFormScolairePerteDeChanceRow,
} from 'src/types/prejudice.type';
import { prejudiceBaseDefaultValues } from '../defaultValues';

type ExistingRow = Omit<Partial<PrejudiceFormScolairePerteDeChance>, 'rows'> & {
  rows?: Partial<PrejudiceFormScolairePerteDeChanceRow>[];
};
type ExistingValues = Omit<Partial<PrejudiceFormScolaire>, 'rows'> & {
  rows?: ExistingRow[];
};

export const scolaireDefaultValues = ({
  values,
}: {
  values?: ExistingValues | undefined;
}): PrejudiceFormScolaire => {
  const baseValues = prejudiceBaseDefaultValues({
    values: values,
  });
  const montant = values?.montant || 0;
  const numerosPieces = values?.numerosPieces || { rows: [] };
  const perteDeChance = {
    rows:
      sortBy(values?.perteDeChance?.rows || [], (row) => row.date).map(
        (row) => ({
          ...defaultScolairePerteDeChanceRow,
          ...row,
          coefficientPerteDeChance: row.coefficientPerteDeChance * 100,
        }),
      ) || [],
    total: values?.perteDeChance?.total || 0,
  };
  const total =
    values?.total || CalculsFormScolaire.getTotal(montant, perteDeChance.total);
  const notes = values?.notes || '';
  return {
    ...baseValues,
    notes,
    montant,
    numerosPieces,
    perteDeChance,
    total,
  };
};

const defaultScolairePerteDeChanceRow: PrejudiceFormScolairePerteDeChanceRow = {
  numerosPieces: { rows: [] },
  libelle: '',
  date: null,
  montant: 0,
  coefficientPerteDeChance: 100,
};
